// register component as global
// define component naming with kebab-case
const brandsmarqueeCmp = Vue.component("brands-marquee-component", {
  template: `<div id="running_p_block" class="running_p_block">
  <ul id="block1">
    <li v-for="n in 17">
       <div class="run-block-item-wrapper my-text-center my-grow">
          <div class="brand-img" v-bind:class="'logo-partner-'+n"></div>
      </div>
    </li>
  </ul>
  <ul id="block2">
  </ul>
</div>`,
  data: function () {
    return {
      uiColorTheme: "light",
      htmlMsg: "",
    };
  },
  mounted() {
    this.uiColorTheme = companyInfo.uiColorTheme;

    let run_main_block = document.getElementById("running_p_block");
    let run_block1 = document.getElementById("block1");
    let run_block2 = document.getElementById("block2");
    run_block2.innerHTML = run_block1.innerHTML;
    setInterval(function () {
      if (run_main_block.scrollLeft >= run_block1.scrollWidth) {
        run_main_block.scrollLeft = 0;
      } else {
        run_main_block.scrollLeft += 1.5;
      }
    }, 20);
  },
});
